
// @flow
import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { ScaleLoader } from 'react-spinners'
import { post } from '../../services/utils'
import { isMobile } from '../../utils'
import { buildUrl } from '../../services/linking'
import 'react-flexbox-grid/lib/index.css'

const clientStatus = {
  PENDING_APPROVAL: 1
}

export default class VerifyAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      error: '',
      title: '',
      message: '',
      url: buildUrl('log-in'),
      isMobile
    }
  }

  async componentDidMount() {
    const { username, verificationCode } = this.props.match.params
    try {
      const url = `${process.env.REACT_APP_API_REST_BASE}/security/confirm-email`
      const result = await post(url, { email: username, code: verificationCode })
      if (result.clientStatus === clientStatus.PENDING_APPROVAL) {
        this.setState({ title: 'Tu cuenta en Wink está en proceso' })
        this.setState({ message: `Estamos verificando tu identidad y te haremos saber tan pronto puedas ingresar a Wink con tus credenciales. Esta verificación usualmente toma entre 6 y 24 horas.` })
        return
      }
      this.setState({ title: 'Tu cuenta en Wink está lista' })
      this.setState({ message: 'Sólo tenés que abrir la aplicación para comenzar a usar Wink' })
    } catch (error) {
      this.setState({ error })
      this.renderErrorMessage(error)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  renderErrorMessage(error) {
    switch (error) {
      case 'security-3':
        this.setState({ title: 'Código inválido' })
        this.setState({ message: 'El código de confirmación es inválido.' })
        break
      case 'security-13':
        this.setState({ title: '¡Oops!' })
        this.setState({ message: 'Ya habías confirmado tu cuenta previamente.' })
        break
      case 'security-14':
        this.setState({ title: '¡Oops!' })
        this.setState({ message: 'Ya habías confirmado tu cuenta previamente.' })
        break
      case 'general-3':
        this.setState({ title: '¡Oops!' })
        this.setState({ message: 'Este usuario no existe.' })
        break
      default:
        this.setState({ title: '¡Oops!' })
        this.setState({ message: 'Algo salio mal, intentá más tarde.' })
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <Grid fluid>
          <Row center="sm">
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className='mainContainer'>
                <Row center="xs">
                  <Col >
                    <div className='winkTopLogo'></div>
                  </Col>
                </Row>
                <Row center="xs">
                  <Col>
                    <div className='tittle'>
                      <ScaleLoader
                        color={'#123abc'}
                        loading={this.state.isLoading}
                      />
                    </div>
                  </Col>
                </Row>
                <Row center="xs">
                  <Col >
                    <div className='message'>Estamos procesando tus datos...</div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Grid>
      )
    }

    return (
      <Grid fluid>
        <Row center="sm">
          <Col xs={12} sm={12} md={12} lg={8}>
            <div className='mainContainer'>
              <Row center="xs">
                <Col >
                  <div className='winkTopLogo'></div>
                </Col>
              </Row>
              <Row center="xs">
                <Col >
                  <div className='tittle'>{this.state.title}</div>
                </Col>
              </Row>
              <Row center="xs">
                <Col >
                  <div className='message'>{this.state.message}</div>
                </Col>
              </Row>
              {!this.state.error && this.state.isMobile.any() && <Row center="xs">
                <Col >
                  <a href={this.state.url} className='btn-primary-outline'>ABRIR EN WINK</a>
                </Col>
              </Row>}
              <Row center="xs">
                <Col xs={12} md={12}>
                  <div className='warningMessage'>Sos parte de la familia Wink. Si necesitás cualquier cosa no dudes
                    contactarnos a través del chat de soporte del App. Nuestro <a href="#">Centro de Soporte</a> siempre está para ayudarte.</div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/VerifyAccount/index.js